import { animation, animate, style } from '@angular/animations';

export const flyOutAnimation = animation([
  animate('0.66s cubic-bezier(0.35, 0, 0.25, 1)', style({ transform: 'translateX(120%)' })),
]);
